export type RevenuePreset = "THIS_MONTH" | "LAST_MONTH" | "THIS_QUARTER" | "LAST_QUARTER" | "THIS_YEAR" | "LAST_YEAR";

export const revenuePresetOptions: { value: RevenuePreset; label: string }[] = [
  { value: "THIS_MONTH", label: "Tháng này" },
  { value: "LAST_MONTH", label: "Tháng trước" },
  { value: "THIS_QUARTER", label: "Quý này" },
  { value: "LAST_QUARTER", label: "Quý trước" },
  { value: "THIS_YEAR", label: "Năm nay" },
  { value: "LAST_YEAR", label: "Năm trước" },
];

export interface RevenueSummary {
  from: string;
  to: string;
  collectCount: number;
  actualRevenue: number;
  expectedRevenue: number;
  difference: number;
}

export type RevenueReconState =
  | "ON_PLAN"
  | "OUT_OF_PLAN"
  | "COLLECTED_BEFORE"
  | "COLLECTED_AFTER"
  | "OVERDUE"
  | "PENDING";

export interface RevenueReconRow {
  id: number;
  content: string;
  debtCount: number;
  amount: number;
  status: string;
  dueDate: string;
  collectedDate: string;
  expectedAmount: number;
  actualAmount: number;
  difference: number;
  state: RevenueReconState;
  order: { id: number; code: string; contractCode: string; opportunityName: string };
  customer: { id: number; name: string } | null;
}

export const revenueReconStateTrans: Record<RevenueReconState, { label: string; color: string; bgcolor: string }> = {
  ON_PLAN: { label: "Đã thu đúng kỳ", color: "#027a48", bgcolor: "#d1fadf" },
  OUT_OF_PLAN: { label: "Thu ngoài kế hoạch", color: "#175cd3", bgcolor: "#eff8ff" },
  COLLECTED_BEFORE: { label: "Đã thu trước kỳ", color: "#667085", bgcolor: "#f2f4f7" },
  COLLECTED_AFTER: { label: "Đã thu sau kỳ", color: "#b54708", bgcolor: "#fffaeb" },
  OVERDUE: { label: "Chưa thu — quá hạn", color: "#b42318", bgcolor: "#fef3f2" },
  PENDING: { label: "Chưa thu — chưa tới hạn", color: "#b54708", bgcolor: "#fffaeb" },
};

export interface RevenueMonthlyPoint {
  month: number;
  revenue: number;
}

export interface RevenueTopCustomer {
  customerId: number;
  customerName: string;
  revenue: number;
}
